

import { closePopup, getPopupRegistration, openPopup, Priority } from 'app/PopupHolder';
import classNames from "classnames";
import Modal from 'components/base/Modal';
import * as Yup from "yup";
import FormikText from '../components/Formik/FormikText';
import moment from 'moment';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePrepaidCredits } from '../../../data/user/actions';
import { selectCardList, selectPrepaidCredits, selectUserId } from '../../../data/user/selectors';
import CreditCardDropdown from '../components/CreditCardDropdown';
import css from "../style.scss";
import { Form, Formik } from 'formik';
import CVV99Modal from "../components/cvv99Modal";
import { getValidationRules } from 'utils/validation';
import numberToPrice from 'utils/currency/numberToPrice';
import LeaveMessagePopup from './LeaveMessage';

const ReloadPrepaidCreditsPopup = (props) => {
  const prepaidInfo = useSelector(selectPrepaidCredits)?.toJS();
  const cardList = useSelector(selectCardList);
  const userId = useSelector(selectUserId);
  const [showCVVModal, setShowCVVModal] = useState(false);
  const dispatch = useDispatch();
  const [selectedCard, setSelectedCard] = useState(cardList[0] || {});
  const validationRules = getValidationRules()

  const handleClose = () => {
    props.closePopup();
  };
  const getFormattedPSTTime = () => {
    return moment()
      .tz('America/Los_Angeles')
      .subtract(moment().isDST() ? 1 : 0, 'hours')
      .format('MMMM D, h:mmA [PST]');
  }

  const handleCardChange = (selectedOption) => {
    setSelectedCard(selectedOption);
  };

  const handleSubmit = async (values) => {
    const payload = {
      userId,
      paymentMethodId: selectedCard?.paymentMethodId,
      amount: Number(values.amount),
    }
    if (Number(values.amount) > 99) {
      setShowCVVModal(true);
      return;
    }
    submitPrepaidCredits(payload);
  }

  const handleSubmitCVV = async (values, cvvValues) => {
    const payload = {
      userId,
      paymentMethodId: selectedCard?.paymentMethodId,
      amount: Number(values.amount),
      cardCode: Number(cvvValues.cardCode),
    }
    submitPrepaidCredits(payload);
  }

  const submitPrepaidCredits = async (payload) => {
    try {
      const response = await updatePrepaidCredits(payload);
      if (response.success) {
        props.getPrepaidCredits();
        props.closePopup();
        setShowCVVModal(false);
      } else {
        console.error(`Update prepaid credits failed:`, response.error);
        setShowCVVModal(false);
        dispatch(LeaveMessagePopup.open({
          title: "Error",
          message: response.error,
          yesLable: "Ok",
          cancelLable: null,
          CancelRedirect: () => null,
          yesRedirect: () => null
        }))
      }
    } catch (error) {
      console.error("Unexpected error:", error);
      setShowCVVModal(false);
      dispatch(LeaveMessagePopup.open({
        title: "Error",
        message: response.error,
        yesLable: "Ok",
        cancelLable: null,
        CancelRedirect: () => null,
        yesRedirect: () => null
      }))
    }
  }

  const validationSchema = Yup.object({
    amount: Yup.number().required("Amount is required").min(5, "Amount must be minimum of $5").max(10000, "Amount must be maximum of $10000")
    .test("decimal-precision", "Amount can have up to 2 decimal places", value =>
      value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
    ),
  })
  const initialValues = {
    amount: "",
  };
  return (
    <Modal modalClassName={css.pricingModal} className={classNames(css.clsAccPageModals, css.clsBillingModal, css.clsAccPrepaidCreditsModal)} isOpen uniqId="ReloadPrepaidCreditsPopup" width="auto" padding="0px 0px 0px" onClose={handleClose}>

      {/* Reload Prepaid Credits */}
      <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0")}>
        <div className={classNames(css.clsModalContent, "modal-content")}>
          <div className={classNames(css.clsModalContentBody, "modal-body")}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                handleSubmit(values, () => {
                  setSubmitting(false);
                })
              }}
            >
              {({ touched, errors, handleSubmit, setFieldValue, values, isSubmitting, setSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className={css.clsModalHeader}>
                    <h2 className={css.clsModalTitle}>Reload Prepaid Credits</h2>
                    <h5 className={classNames(css.clsModalSubTitle, css.clsReloadSubTitle,)}>
                      Prepaid Credits can be used for Marketing, Skip Tracing, and Document Purchases.
                    </h5>
                  </div>

                  <div className={classNames(css.clsModalBody)}>
                    <div className={classNames(css.clsModalBodyInner, "clearfix w-100")}>
                      {prepaidInfo?.remainingPrepaidCredit > 0 && <><h2 className={css.clsModalTitle2}>{numberToPrice(prepaidInfo?.remainingPrepaidCredit)}</h2>
                      <h5 className={css.clsModalSubTitle3}>
                        Current Balance as of {getFormattedPSTTime()}
                      </h5></>}

                      <div className={classNames("clearfix")}>
                        <div className={classNames(css.clsFormGroup, css.pl_16, css.pr_16, css.pt_32)}>
                          <label className={classNames(css.clsFormLabel)}> Payment Method</label>
                          <CreditCardDropdown
                            tag={false}
                            options={cardList}
                            paymentMethodType={'In-App Purchases'}
                            onChange={(selectedOption) => handleCardChange(selectedOption)}
                          />
                        </div>
                        <div className={classNames(css.clsFormGroup, css.pl_16, css.pr_16, css.pt_32)}>
                          <label className={classNames(css.clsFormLabel)}>Amount
                            <span className={classNames(css.text_gray, css.text_m)}> (Min. $5)</span>
                          </label>
                          <div className={classNames(css.clsFormGroup)}>
                            <FormikText 
                              name="amount" label="" 
                              type='number'
                              placeholder="Enter Amount"
                              errors={errors} 
                              touched={touched} 
                              maxLength={validationRules.maxLength.prepaidCredit}
                              validationPattern={validationRules.validationPattern.prepaidCredit} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={classNames(css.clsModalFooter)}>
                    <button className={classNames(css.btn_lg, css.btn_primary, css.text_primary,)} onClick={handleClose}> Cancel</button>
                    <button className={classNames(css.btn_lg, css.clsBtnOrng)} disabled={isSubmitting} type="submit">  Purchase Credits </button>
                  </div>
                  {showCVVModal && <CVV99Modal
                      showCVVModal={showCVVModal} cardEnding={selectedCard?.cardEnding} cvvLength={selectedCard?.cardCVVLength} handleSubmitCVV={(cvvValues) => handleSubmitCVV(values, cvvValues)} 
                      handleCancel={() => {setShowCVVModal(false); setSubmitting(false)}} handleClose={() => {setShowCVVModal(false); setSubmitting(false)}}  />}

                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Modal >


  );
};


const registrationId = getPopupRegistration(ReloadPrepaidCreditsPopup);
ReloadPrepaidCreditsPopup.open = (props = {}) => openPopup(registrationId, { ...props, priority: Priority.MEDIUM });
ReloadPrepaidCreditsPopup.close = () => closePopup({ popup: registrationId });

export default ReloadPrepaidCreditsPopup;
